export let IntegrationStatus;
(function (IntegrationStatus) {
  IntegrationStatus["CONNECTED"] = "CONNECTED";
  IntegrationStatus["THIRD_PARTY_MISSING_SCOPE_ERROR"] = "THIRD_PARTY_MISSING_SCOPE_ERROR";
  IntegrationStatus["DELAY"] = "DELAY";
  IntegrationStatus["AUTH_ERROR"] = "AUTH_ERROR";
  IntegrationStatus["DEPRECATED_AUTH_TOKEN"] = "DEPRECATED_AUTH_TOKEN";
  IntegrationStatus["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  IntegrationStatus["THIRD_PARTY_AVAILABILITY_ERROR"] = "THIRD_PARTY_AVAILABILITY_ERROR";
})(IntegrationStatus || (IntegrationStatus = {}));